import MobileOrDesktopDialog from '../mobileOrDesktopDialog';
import CallHelp from '@/assets/Icons/call-help.svg';
import { IVR_DATA } from '@/constants';
import { useSelector } from 'react-redux';

const Help = ({ show, onClose }: any) => {
    const data = useSelector(
        (state: any) =>
            state.garage?.timeline?.latest_stage_details?.common_details || {}
    );
    const service_advisor_number = data.service_advisor_number;

    const handleCall = (number: string) => {
        window.open(`tel:${number}`, '_self');
    };

    const formatPhoneNumber = (number: string) => {
        return number.replace(/(\d{4})(\d{3})(\d{4})/, '$1 $2 $3');
    };

    return (
        <MobileOrDesktopDialog
            show={show}
            onClose={() => onClose(false)}
            isMobile
        >
            <div>
                <div className="help-container">
                    <div className="help-content">
                        <CallHelp />
                        <p className="help-title">Need more help?</p>
                        <p className="helper-text">
                            You can call your service advisor or reach our
                            toll-free support team.
                        </p>
                    </div>
                    <div className="help-cta">
                        <button
                            className="primary-button"
                            onClick={() => handleCall(service_advisor_number)}
                        >
                            Call your service advisor
                        </button>
                        <a
                            className="secondary-cta"
                            onClick={() =>
                                handleCall(IVR_DATA.SERVICE_ADVISOR_NUMBER)
                            }
                        >
                            {'Toll-free support '}
                            {formatPhoneNumber(IVR_DATA.SERVICE_ADVISOR_NUMBER)}
                        </a>
                    </div>
                </div>
                <style jsx>{`
                    .help-container {
                        display: flex;
                        flex-direction: column;
                        gap: 24px;
                    }
                    .help-content {
                        display: flex;
                        flex-direction: column;
                        gap: 16px;
                    }
                    .help-title {
                        margin: 0;
                        color: #121212;
                        font-size: 20px;
                        font-weight: 600;
                        line-height: 28px;
                        letter-spacing: -0.1px;
                    }
                    .helper-text {
                        margin: 0;
                        color: #4b4b4b;
                        font-size: 16px;
                        font-weight: 400;
                        line-height: 24px;
                    }
                    .help-cta {
                        display: flex;
                        flex-direction: column;
                        gap: 16px;
                    }
                    .primary-button {
                        display: flex;
                        height: 48px;
                        padding: 10px 16px;
                        justify-content: center;
                        align-items: center;
                        align-self: stretch;
                        border: none;
                        border-radius: 8px;
                        background: #121212;
                        color: #fff;
                        text-align: center;
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 24px;
                        width: 100%;
                    }
                    .secondary-cta {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: #1b73e8;
                        font-size: 14px;
                        font-weight: 500;
                        line-height: 20px;
                    }
                `}</style>
            </div>
        </MobileOrDesktopDialog>
    );
};

export default Help;
